import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en_US from './en_US'
import zh_CN from './zh_CN'
import usePersistDataStore from '@/stores/persistData'

i18n.use(initReactI18next).init({
  resources: {
    en_US: { translation: en_US },
    zh_CN: { translation: zh_CN },
  },
  lng: usePersistDataStore.getState().lang,
  fallbackLng: usePersistDataStore.getState().lang,
  debug: false,
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
})

export default i18n
